import { render } from "./GreetingUser.vue?vue&type=template&id=0712bd77&scoped=true"
import script from "./GreetingUser.vue?vue&type=script&lang=js"
export * from "./GreetingUser.vue?vue&type=script&lang=js"

import "./GreetingUser.vue?vue&type=style&index=0&id=0712bd77&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0712bd77"]])

export default __exports__